module.exports = __webpack_public_path__ + "img/52.0fbd8f1a.png";